import { Box, CardContent, CardHeader } from '@mui/material';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  StyledCard,
  StyledIconWrapper,
  StyledPlanText,
  StyledTaxText,
  StyledText,
} from './InstanceStepper.styles';
import { INSTANCE_CATEGORY } from '../../../constants';
import { currencyFormat } from '../../../utils/paymentUtils';

const PlanCard = ({ plan, community }) => {
  const { t } = useTranslation();

  const { name, category, description, price, features } = plan;
  const isCommunity = category === INSTANCE_CATEGORY.COMMUNITY;

  // Maximum community instances allowed: 2
  const communityAvailable = 2 - community;

  return (
    <StyledCard
      aria-label={`${name}-plan`}
      ownerState={{ isCommunity: isCommunity }}
    >
      <CardHeader
        title={t(capitalize(name), { ns: 'menus' })}
        subheader={t(description, { ns: 'menus' })}
        titleTypographyProps={{
          align: 'center',
          sx: {
            color: 'white',
            fontWeight: 'bold',
            fontSize: '1.25em',
          },
        }}
        subheaderTypographyProps={{
          align: 'center',
          sx: {
            color: 'white',
          },
        }}
        sx={{ marginBottom: '-1.5em' }}
      />
      <CardContent>
        <Box sx={{ mb: 3 }}>
          <StyledPlanText align="center">
            {isCommunity
              ? t('features.free', { ns: 'menus' })
              : currencyFormat(price)}
          </StyledPlanText>
          <StyledTaxText align="center">
            {isCommunity
              ? t('remaining', { ns: 'general', number: communityAvailable })
              : t('features.monthlyNoTax', { ns: 'menus' })}
          </StyledTaxText>
        </Box>
        {features.map((feature) => (
          <Box
            key={feature.content}
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            aria-label="feature item"
          >
            <StyledIconWrapper>{feature.icon}</StyledIconWrapper>
            <StyledText>{t(feature.content, { ns: 'menus' })}</StyledText>
          </Box>
        ))}
      </CardContent>
    </StyledCard>
  );
};

PlanCard.propTypes = {
  plan: PropTypes.object.isRequired,
  community: PropTypes.number.isRequired,
};

export default PlanCard;
